import apiClient from '../lib/apiClient';

export interface Memo {
    id: string;
    memo: string;
    createDateTime: string;
    modifyDateTime: string;
}

export interface MemoListResponse {
    content: Memo[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
}

// 목록 조회 (Postman 명세에 따라 POST 방식 사용)
export const getMemoList = (page = 0, size = 10) =>
    apiClient.post<MemoListResponse>(`/memo/list?page=${page}&size=${size}&sort=createDateTime,desc`);

// 단건 조회
export const getMemo = (id: string) =>
    apiClient.get<Memo>(`/memo/${id}`);

// 생성
export const createMemo = (memo: string) =>
    apiClient.post('/memo', { memo });

// 수정
export const modifyMemo = (id: string, memo: string) =>
    apiClient.put('/memo', { id, memo });

// 삭제 (ID 배열 전달)
export const deleteMemos = (ids: string[]) =>
    apiClient.delete('/memo', { data: { ids } });